import {NgModule} from '@angular/core';
import {ControlStateDirective} from './control-state.directive';

@NgModule({
  declarations: [
    ControlStateDirective
  ],
  exports: [
    ControlStateDirective
  ]
})
export class FormBaseModule {
}
